import { ReloadOutlined } from '@ant-design/icons';
import { getProjectDetail } from '@api/announcement';
import { projectRecall, updateProject } from '@api/project';
import ZeissButton from '@components/button';
import { PROJECT_MODE } from '@components/ProjectFromComponents/data';
import RevertModal from '@components/revertModal';
import { ROLE_KEYS_MAP } from '@constants';
import { DicListHook } from '@hooks/useDicListHook';
import { UseSystemCity } from '@hooks/useSystemCity';
import { userInfo } from '@store';
import { Form, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import { CreateProject } from '../../../components/ProjectFromComponents/CreateProject';
import { useTimeLine } from '../../../components/useTimeLine/useTimeLine';
import { DataFlagEnum } from '../AnnouncementList/announcement';
import { useFooter } from './hooks/Footer/useFooter';
import { useBaseInfo } from './hooks/ProjectDetails/BaseInfo/useBaseInfo';
import { useInfoHead } from './hooks/ProjectDetails/BaseInfo/useInfoHead';
import { useRelatedAnnouncement } from './hooks/ProjectDetails/RelatedAnnouncement/useRelatedAnnouncement';
import { useSalesFeedBack } from './hooks/ProjectDetails/SalesFeedBack/useSalesFeedBack';
import { useSubjectMatter } from './hooks/ProjectDetails/SubjectMatter/useSubjectMatter';
import { RecordSceneEnum } from './type';
import './index.scss';

const ProjectDetail = () => {
  const [details, setDetails] = useImmer<any>({});
  const [userInfos] = useRecoilState(userInfo);
  const [editOpen, setEditOpen] = useState(false);
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false);
  const [form] = Form.useForm();
  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;
  // 编辑按钮
  const handleClickEditBtn = () => {
    setEditOpen(!editOpen);
  };
  const { infoHeadComponent } = useInfoHead({ details }); //公告标题和类型
  const { baseInfoComponent } = useBaseInfo({ details }); // 公告信息
  const { timeLineComponent, getHistoryList } = useTimeLine({
    details,
    recordScene: RecordSceneEnum['sales'],
    hideForward: true
  }); // 公告信息
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dict = DicListHook();
  const { data: systemCity } = UseSystemCity();
  const getAnnInfo = async () => {
    const res = await getProjectDetail(
      `${searchParams.get('noticeProjectCode') || ''}`
    );
    setDetails(res || {});
    getHistoryList();
  };

  const onRevertConfirm = async () => {
    const params = {
      code: searchParams.get('noticeProjectCode') || '',
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await projectRecall(params);
    getAnnInfo();
    setRevertModalShow(false);
  };

  const { relatedAnnouncementComponent } = useRelatedAnnouncement({
    details,
    getAnnInfo
  }); // 相关公告

  const { projectFooterComponent, leadsData } = useFooter({
    details,
    noticeCode: details?.noticeCode || '',
    getAnnInfo,
    handleClickEditBtn
  });
  //标的物
  const { subMatterComponent } = useSubjectMatter({
    details,
    getAnnInfo,
    dict,
    systemCity,
    handleClickEditBtn
  });
  //销售反馈
  const { salesFeedBackComponent } = useSalesFeedBack({
    details,
    dict,
    handleClickEditBtn,
    leadsData
  });

  const handleProjectFormOk = async (data: any) => {
    await updateProject({
      ...data
    });
    handleClickEditBtn();
    form.resetFields();
    await getAnnInfo();
  };

  useEffect(() => {
    getAnnInfo();
  }, [location]);

  return (
    <div className="pc-proDetail-container">
      <div className="pc-proDetail-layout">
        {infoHeadComponent}
        <div className="pc-proDetail-tit">
          <div>
            项目信息
            {details.dataFlag === DataFlagEnum.dealer ? (
              <span className="pc-annDetail-tit-dealer">经销</span>
            ) : (
              <span className="pc-annDetail-tit-sales">直销</span>
            )}
          </div>
          {details?.deleteStatus ? null : (
            <a className="pc-detail-edit-btn" onClick={handleClickEditBtn}>
              编辑
            </a>
          )}
        </div>
        {baseInfoComponent}
        {subMatterComponent}
        {salesFeedBackComponent}
        {relatedAnnouncementComponent}
        {details?.deleteStatus ? (
          <Space size={'middle'} className="pc-footer-position">
            {!isDealer && (
              <ZeissButton
                type="default"
                className="pc-footer-btn"
                danger
                onClick={() => setRevertModalShow(true)}
              >
                <ReloadOutlined
                  rotate={-30}
                  style={{ transform: 'scaleX(-1)' }}
                />{' '}
                撤回项目
              </ZeissButton>
            )}
          </Space>
        ) : (
          projectFooterComponent
        )}
      </div>
      <div className="pc-proDetail-history">{timeLineComponent}</div>
      <CreateProject
        mode={PROJECT_MODE.EDIT}
        formRef={form}
        noticeRecord={details}
        record={details}
        dicList={dict}
        handleOk={handleProjectFormOk}
        open={editOpen}
        setOpen={handleClickEditBtn}
        systemCity={systemCity}
        handleCancel={handleClickEditBtn}
      />
      <RevertModal
        title="请确认是否撤回该公告?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
    </div>
  );
};
export default ProjectDetail;
